"use client";

import { createContext, useContext, type ReactNode } from "react";

export interface CanvasResolvedResource {
  downloadUrl: string;
  previewUrl?: string;
  name?: string;
  mimeType?: string;
}

export type CanvasResourceResolver = (
  uri: string,
) => Promise<CanvasResolvedResource | null>;

const ResourceResolverContext = createContext<CanvasResourceResolver | undefined>(undefined);

export function CanvasResourceResolverProvider({
  children,
  resolveResource,
}: {
  children: ReactNode;
  resolveResource?: CanvasResourceResolver;
}) {
  return (
    <ResourceResolverContext.Provider value={resolveResource}>
      {children}
    </ResourceResolverContext.Provider>
  );
}

export function useCanvasResourceResolver(): CanvasResourceResolver | undefined {
  return useContext(ResourceResolverContext);
}
